var _path, _rect, _path2, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetRandomName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5551 18.0964C49.9421 20.5434 49.9421 23.539 48.5551 25.986L45.3566 31.6292L42.0687 37.2208C40.643 39.6454 38.0488 41.1432 35.2361 41.1656L28.7498 41.2171L22.2634 41.1656C19.4508 41.1432 16.8565 39.6454 15.4308 37.2208L12.143 31.6292L8.94444 25.986C7.55748 23.539 7.55748 20.5434 8.94443 18.0964L12.143 12.4533L15.4308 6.86172C16.8565 4.43708 19.4508 2.93928 22.2634 2.91692L28.7498 2.86536L35.2361 2.91692C38.0488 2.93928 40.643 4.43708 42.0687 6.86173L45.3566 12.4533L48.5551 18.0964Z",
    fill: "#FBD178"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.958008,
    y: 44.0825,
    width: 40.2492,
    height: 3.83326,
    rx: 1.91663,
    fill: "#FBD178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.9158H5.05232C5.90016 47.9158 6.36332 46.9269 5.82054 46.2756L1.76822 41.4128C1.16946 40.6943 0 41.1177 0 42.053V46.9158C0 47.468 0.447715 47.9158 1 47.9158Z",
    fill: "#FBD178"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.916 47.9157L24.916 24.437C24.916 22.0553 26.8468 20.1246 29.2284 20.1246C31.6101 20.1246 33.5409 22.0553 33.5409 24.437L33.5409 47.9157L24.916 47.9157Z",
    fill: "#3BCFE9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2288,
    cy: 24.437,
    r: 2.39579,
    fill: "#3BCFE9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.66658,
    cy: 37.3743,
    r: 4.79158,
    fill: "#3BCFE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetRandomName);
export default __webpack_public_path__ + "static/media/WIDGET_RANDOM_NAME.c595ded139384546c1096e0b864be659.svg";
export { ForwardRef as ReactComponent };